import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

// Firebase configuration using environment variables
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyCS9sX31OLbKKcl0SKOfcqCUyQCFLwa3x0",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "platinum-banner-471212-f2.firebaseapp.com",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "platinum-banner-471212-f2",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "775990417119",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:775990417119:web:11c818233b0183524b3b6a",
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-2W3Y2HBXKK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Connect to emulators in development
if (import.meta.env.DEV) {
    const emulatorHost =
        typeof window !== 'undefined' && window.location?.hostname
            ? window.location.hostname
            : 'localhost';
    connectAuthEmulator(auth, `http://${emulatorHost}:9099`, { disableWarnings: true });
    connectFirestoreEmulator(db, emulatorHost, 8080);
}

// Export the app instance for analytics if needed
export default app;
